// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"2dc180eb","453":"6c5d3840"}[chunkId] + ".chunk.js";
};